import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-client',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './client.component.html',
  styleUrl: './client.component.scss'
})
export class ClientComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/client-edit/';
  override addLink = '/dashboard/client-create';
  verifiedMap: {value: string, label: string}[] = [
    {value: 'true', label: 'Yes'},
    {value: 'false', label: 'No'},
  ];
  blockedMap: {value: string, label: string}[] = [
    {value: 'true', label: 'Yes'},
    {value: 'false', label: 'No'},
  ];

  constructor(crudService: CrudService,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('client');
  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Email',
        field: 'email',
        sortable: false,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Created At',
        field: 'createdAt',
        sortable: false,
        filterType: EFilterType.DATE,
        value: (item) => (new Date(item.createdAt || Date.now())).toLocaleString(),
        crudFilterType: ECrudFilterType.DATE,
      },
      {
        header: 'Verified',
        field: 'verified',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: (item) => item.verified ? 'Yes' : "No",
        options: () => this.verifiedMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Blocked',
        field: 'blocked',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: (item) => item.blocked ? 'Yes' : "No",
        options: () => this.blockedMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Two Factor',
        field: 'twoFactor',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: (item) => item.twoFactor ? 'Yes' : "No",
        options: () => this.blockedMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Subscribe Mails',
        field: 'subscribeMails',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: (item) => item.subscribeMails ? 'Yes' : "No",
        options: () => this.blockedMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();
  }
}
